exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lds-circle[data-v-612d12e6]{display:inline-block;transform:translateZ(1px)}.lds-circle>div[data-v-612d12e6]{display:inline-block;width:15px;height:15px;margin-right:8px;border-radius:50%;background:#108370;animation:lds-circle 2.4s cubic-bezier(0,.2,.8,1) infinite}.accion[data-v-612d12e6]{background:#f0eeee;padding:5px 20px;border-radius:15px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-612d12e6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/AdminMessages.vue
// module id = 602
// module chunks = 0